<template>
  <div>
    <table-view
      ref="tableList"
      is-search-row
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="Third Key 管理"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void(0)"
          class="icon-pencil1"
          style="margin-right: 12px; color: #3a3f63"
          @click="handleEdit(tableRow.row)"
        />

        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleDelete(tableRow.row.apiKey)"
        >
          <a
            href="javascript:void(0)"
            class="icon-trash1"
            style="margin-right: 12px; color: #3a3f63"
            slot="reference"
          />
        </el-popconfirm>

        <el-popconfirm
          v-if="tableRow.row.isValid === 1"
          title="Confirm to invalidate？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="openInvalidateDialog(tableRow.row.apiKey)"
        >
          <customize-button
            slot="reference"
            class="action-btn"
            size="medium"
            :btnStyle="{ marginRight: '12px', background: '#e41e20', color: '#fff', boxShadow: 'none' }"
          >
            Invalidate
          </customize-button>
        </el-popconfirm>

        <el-popconfirm
          v-else
          title="Confirm to enable？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleEnable(tableRow.row.apiKey)"
        >
          <customize-button slot="reference" class="action-btn" size="medium" type="primary">
            Enable
          </customize-button>
        </el-popconfirm>
      </template>
    </table-view>

    <!-- Add dialog -->
    <el-dialog
      :visible.sync="addVisible"
      title="Add Third Key"
      width="462px"
      @close="handleAddClose"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-card :bordered="false">
        <el-form :model="addForm" ref="addFormRef" label-position="top" :rules="addRules">
          <el-form-item label="API Key" prop="apiKey">
            <el-input style="width: 100%" v-model="addForm.apiKey" maxlength="100" />
          </el-form-item>
          <el-form-item label="Name" prop="name">
            <el-input style="width: 100%" v-model="addForm.name" maxlength="100" />
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer">
        <customize-button style="margin-right: 20px" @click="addVisible = false">Cancel</customize-button>
        <customize-button type="primary" @click="handleAddSave" :loading="isSubmitting">Save</customize-button>
      </div>
    </el-dialog>

    <!-- Edit dialog -->
    <el-dialog
      :visible.sync="editVisible"
      title="Edit Third Key"
      width="462px"
      @close="handleEditClose"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-card :bordered="false">
        <el-form :model="editForm" ref="editFormRef" label-position="top" :rules="editRules">
            <el-form-item label="API Key">
              <el-input
                style="width: 100%"
                :value="truncateKey(editForm.apiKey)"
                disabled
              />
            </el-form-item>
          <el-form-item label="Name" prop="name">
            <el-input style="width: 100%" v-model="editForm.name" maxlength="100" />
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer">
        <customize-button style="margin-right: 20px" @click="editVisible = false">Cancel</customize-button>
        <customize-button type="primary" @click="handleEditSave" :loading="isSubmitting">Save</customize-button>
      </div>
    </el-dialog>

    <!-- Invalidate dialog (collect reason) -->
    <el-dialog
      :visible.sync="invalidateVisible"
      title="Invalidate Third Key"
      width="462px"
      @close="handleInvalidateClose"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-card :bordered="false">
        <el-form :model="invalidateForm" ref="invalidateFormRef" label-position="top">
          <el-form-item label="Invalid Reason">
            <el-input type="textarea" v-model="invalidateForm.invalidReason" maxlength="255" />
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer">
        <customize-button style="margin-right: 20px" @click="invalidateVisible = false">Cancel</customize-button>
        <customize-button type="primary" @click="handleInvalidateConfirm" :loading="isSubmitting">Confirm</customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTableData,
  addThirdKey,
  updateThirdKey,
  deleteThirdKey,
  invalidateThirdKey,
  enableThirdKey,
} from './api'

export default {
  data() {
    const searchModel = [
      { label: 'Name', key: 'name', type: 'input', layout: { xl: 6 } },
      {
        label: 'Status',
        key: 'isValid',
        type: 'select',
        layout: { xl: 6 },
        selectList: [
          { id: '', name: 'All' },
          { id: 1, name: '可用' },
          { id: 0, name: '无效' },
        ],
      },
    ]

    const tableModel = [
      { label: 'API Key', prop: 'apiKeyDisplay' },
      { label: 'Name', prop: 'name' },
      { label: 'Status', prop: 'isValidStr' },
      { label: 'Invalid Reason', prop: 'invalidReason' },
      { label: 'Action', width: 260, slotName: 'action' },
    ]

    return {
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      addVisible: false,
      editVisible: false,
      invalidateVisible: false,
      addForm: { apiKey: '', name: '' },
      editForm: { apiKey: '', name: '' },
      invalidateForm: { apiKey: '', invalidReason: '' },
      addRules: {
        apiKey: [
          { required: true, trigger: 'blur', message: 'API Key is required' },
        ],
        name: [
          { required: true, trigger: 'blur', message: 'Name is required' },
        ],
      },
      editRules: {
        name: [{ required: true, trigger: 'blur', message: 'Name is required' }],
      },
      isSubmitting: false,
    }
  },
  mounted() {
    this.initTable()
  },
  methods: {
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    // helper to truncate apiKey for display: first 10 + fixed 15 '*' + last 6
    truncateKey(key) {
      if (!key) return ''
      const s = String(key)
      if (s.length <= 16) return s
      return `${s.slice(0, 10)}${'*'.repeat(15)}${s.slice(-6)}`
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        // Map numeric status to human readable text for display but keep original isValid for logic
        this.tableData = (data || []).map(row => {
          const r = {
            ...row,
            isValidStr:
              row.isValid === 1
                ? '可用'
                : row.isValid === 0
                ? '无效'
                : row.isValid === 2
                ? '无效'
                : String(row.isValid),
            apiKeyDisplay: (() => {
              if (!row.apiKey) return ''
              const s = String(row.apiKey)
              if (s.length <= 16) return s
              return `${s.slice(0, 10)}${'*'.repeat(15)}${s.slice(-6)}`
            })(),
          }
          // format dates for display using dayjs
          try {
            if (r.updatedAt) {
              r.updatedAt = this.$dayjs(r.updatedAt).format('YYYY-MM-DD HH:mm:ss')
            }
            if (r.invalidatedAt) {
              r.invalidatedAt = this.$dayjs(r.invalidatedAt).format('YYYY-MM-DD HH:mm:ss')
            }
          } catch (e) {
            // ignore formatting errors
          }
          return r
        })
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    handleTitleActionBtn() {
      this.addVisible = true
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.resetFields()
        this.addForm = { apiKey: '', name: '' }
      })
    },
    // Add
    async handleAddSave() {
      try {
        const valid = await this.$refs.addFormRef.validate()
        if (valid) {
          // 防重复提交：isSubmitting 在请求开始时置为 true，请求结束或失败后恢复为 false
          if (this.isSubmitting) return
          this.isSubmitting = true
          try {
            await addThirdKey(this.addForm)
            this.$message.success('success')
            this.addVisible = false
            this.initTable()
          } catch (err) {
            // error handled by request wrapper (shows msg) but still log
            console.error(err)
          } finally {
            this.isSubmitting = false
          }
        }
      } catch (err) {
        // validation throws when invalid
      }
    },
    handleAddClose() {
      this.$refs.addFormRef && this.$refs.addFormRef.resetFields()
    },
    // Edit
    handleEdit(row) {
      this.editVisible = true
      this.editForm = { apiKey: row.apiKey, name: row.name }
      this.$nextTick(() => {
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
      })
    },
    async handleEditSave() {
      try {
        const valid = await this.$refs.editFormRef.validate()
        if (valid) {
          // 防重复提交：避免重复调用更新接口
          if (this.isSubmitting) return
          this.isSubmitting = true
          try {
            await updateThirdKey(this.editForm.apiKey, { name: this.editForm.name })
            this.$message.success('success')
            this.editVisible = false
            this.initTable()
          } catch (err) {
            console.error(err)
          } finally {
            this.isSubmitting = false
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleEditClose() {
      this.$refs.editFormRef && this.$refs.editFormRef.resetFields()
    },
    // Delete
    async handleDelete(apiKey) {
      try {
        await deleteThirdKey(apiKey)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
    // Invalidate flow: open dialog to collect reason, then call
    openInvalidateDialog(apiKey) {
      this.invalidateForm = { apiKey, invalidReason: '' }
      this.invalidateVisible = true
    },
    async handleInvalidateConfirm() {
      try {
        // 防重复提交标志
        if (this.isSubmitting) return
        this.isSubmitting = true
        try {
          await invalidateThirdKey(this.invalidateForm.apiKey, {
            invalidReason: this.invalidateForm.invalidReason,
          })
          this.$message.success('success')
          this.invalidateVisible = false
          this.initTable()
        } catch (err) {
          console.error(err)
        } finally {
          this.isSubmitting = false
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleInvalidateClose() {
      this.invalidateForm = { apiKey: '', invalidReason: '' }
    },
    // Enable
    async handleEnable(apiKey) {
      try {
        await enableThirdKey(apiKey)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.icon-trash1 {
  cursor: pointer;
}

/* make action buttons have consistent width */
.action-btn {
  min-width: 92px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>

